import { DELETE_BTN_CONTAINER_STYLE, MARGIN_10PX, SUBMIT_MSG } from "../../utils/constants/GlobalConstants";
import ButtonLayout from "../common/button/ButtonLayout";


const SubmitDebi = (props) => {
  return (
    <>
       <div>{SUBMIT_MSG} </div>
      <div style={DELETE_BTN_CONTAINER_STYLE}>
        <ButtonLayout testid="ok" label="OK" style={MARGIN_10PX} onClickBtn={() => props.okClicked()} />&nbsp; &nbsp;
        <ButtonLayout testid="cancel" label="Cancel" style={MARGIN_10PX} onClickBtn={()=>{props.cancelClicked()}} />
      </div>
    </>
  );
};
export default SubmitDebi;
